import { DOCUMENT } from '@angular/common';
import { Directive, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Asset, InstrumentType, ProtectOrderModel } from '@zero/shared/util-models';
import { TradeFacade, TradeService } from '@zero/trade/domain';
import { AnimationOptions } from 'ngx-lottie';
import { firstValueFrom } from 'rxjs';

@Directive()
export class TradeSuccessPageBase {
  public readonly router = inject(Router);
  public readonly activatedRoute = inject(ActivatedRoute);
  public readonly tradeService = inject(TradeService);
  public readonly document = inject(DOCUMENT);
  readonly #tradeFacade = inject(TradeFacade);

  public isReady?: boolean;
  public options: AnimationOptions = {
    path: '/assets/animatedgraphics/checkmark-update.json',
    loop: false,
  };
  public asset: Asset;
  public quantity: number;
  public direction: 'buy' | 'sell';
  public derivateType = InstrumentType.Derivative;

  public async init(): Promise<void> {
    const cache = await firstValueFrom(this.tradeService.cache$);
    this.isReady = Boolean(cache?.form && cache?.asset);
    if (this.isReady) {
      this.tradeService.updateInstrument(cache.asset);
      this.asset = cache.asset;
      this.direction = cache.form.get('direction').value;
      this.quantity = cache.form.get('quantityForm').get('quantity').value as number;
    }
  }

  public destroy(): void {
    this.tradeService.reset();
    this.#tradeFacade.reset();
  }

  public getProtectOrderParams = (protectOrderModel: ProtectOrderModel): Params => {
    const { asset, form } = this.tradeService.cache;
    if (!asset || !form) {
      throw new Error('protect order failed');
    }

    const { isin } = asset;
    const { validity, stop } = protectOrderModel;
    return {
      isin,
      quantity: Math.floor(+form.get('quantityForm').get('quantity').value),
      direction: 'sell',
      execType: 'stop',
      validity: validity.toJSON(),
      stopPrice: stop,
    };
  };
}
